export default function() {
  const sendButton = document.querySelector('#works-list-status-change');

  if (!sendButton) {
    return;
  }

  const worksListStatusForm = document.querySelector('#works-list-status-form');

  if (!worksListStatusForm) {
    return;
  }

  sendButton?.addEventListener('click', function (e) {
    e.preventDefault();

    const moderationStatus = document.querySelector('input[name="moderation"]:checked');

    if (!moderationStatus) {
      return;
    }

    const checkedItems = document.querySelectorAll('input[name="checked_items[]"]:checked');

    if (!checkedItems) {
      return;
    }

    checkedItems.forEach(function (item) {
      const workItemInput = document.createElement('input');
      workItemInput.setAttribute('type', 'hidden');
      workItemInput.setAttribute('name', 'checked_items[]');
      workItemInput.setAttribute('value', item.value);

      worksListStatusForm.appendChild(workItemInput);
    });

    worksListStatusForm.submit();
  });
}